export default () => ({
  campaigns: [
    {
      id: 200001,
      wineId: 100001,
      type: 'wine-of-month',
      active: true,
      price: '6,90',
      discount: '6,00',
      currency: '€',
      description: [
        '',
        'Unser Riesling ist der Gutswein des renommierten VdP-Weingutes Burg Ravensburg aus dem Kraichgau in Baden, etwas südlich von Heilbronn. Das 38 Hektar große Weingut wird im deutschen Weinführer Gault Millau von 2019 mit 4 von 5 Trauben bewertet! Außerdem wird das Weingut seit 2010 ökologisch bewirtschaftet. Wir haben es also mit einem Wein zu tun, der von einem deutschen Spitzenbetrieb biologisch erzeugt wird!',
        'Der Gutsriesling zeigt sich in einem schönen, hellen Strohgelb und erfreut die Nase mit einem Bukett von Zitrusfrucht, Aprikose, Birne und Quitte. Im Mund wirkt der Wein leicht bis mittelgewichtig (nur 11,5 % Vol.) und ist dabei fein und elegant. Die Säure ist angenehm zurückhaltend und im Hintergrund schmeckt man sanft Mineralität. Der Abgang mittellang!',
        'So schön und günstig kann badischer Riesling sein!',
      ],
      media: {
        imgSrc: '/img/wine/burg-ravensburg_riesling_2018.jpg',
      },
      beginCampaign: '2019-05-01T08:00:00.000+02:00',
      endCampaign: '2019-05-31T20:00:00.000+02:00',
      slug: '19-05',
    },
    {
      id: 200002,
      wineId: 100002,
      type: 'wine-of-month',
      active: true,
      price: '5,90',
      discount: '5,40',
      currency: '€',
      description: [
        '',
        'Die wunderbar klare Lachsfarbe unseres Spätburgunder Rosé vom Weingut Jesuitenhof von Klaus Schneider aus Dirmstadt, Pfalz, wird durch die weiße Schlegelflasche voll zur Geltung gebracht. Gut gemacht!',
        'Aromen von reifen Limetten, roten Johannisbeeren und intensiver Blütenduft schmeicheln der Nase beim Verkosten. Ein tolles Bukett!',
        'Im Mund wirkt der reine Spätburgunder frisch und enorm spritzig, dabei ist er schlank, feingliedrig und sehr elegant. Absolut trocken endet unser Rosé mit einem mittellangen Abgang!',
        '',
        'Für nur 5,90 € (im Juni 2019 für nur 5,40 €) erhalten Sie reines Trinkvergnügen! Probieren!',
      ],
      media: {
        imgSrc: '/img/wine/jesuitenhof_spaetburgunder-rose_2018.png',
      },
      beginCampaign: '2019-06-01T08:00:00.000+02:00',
      endCampaign: '2019-06-30T20:00:00.000+02:00',
      slug: '19-06',
    },
    {
      id: 200003,
      wineId: 100003,
      type: 'wine-of-month',
      active: true,
      price: '8,00',
      discount: '7,50',
      currency: '€',
      description: [
        '',
        'Wir bieten Ihnen in diesem Monat eine trockene Cuvée vom Weingut Christian Bamberger aus Bad Sobernheim an der Nahe. Entstanden ist sie aus der spannenden Kombination der drei Rebsorten Silvaner, Sauvignon Blanc und Bacchus und wurde dementsprechend "Vielfalt" genannt. Vielfalt finden wir auch in der komplexen Aromatik wieder: wir entdecken feinfruchtige Noten nach Birnen und Mandarinen vom Silvaner, kräftig fruchtige Noten typisch für den Sauvignon und einen würzigen Muskatton vom Bacchus. Vielfalt ist ausdrucksstark!',
        'Im Mund wirkt der Wein frisch, die Säure ist aber weich und gut eingebunden. Der Wein ist komplex und hat dazu einen schönen, langen und nachhaltigen Abgang!',
        'Unsere Vielfalt harmoniert kulinarisch gut mit leichten Vorspeisen, Gemüsegerichten, asiatischen Reisgerichten, Fisch und Geflügel.',
        'Für 8,00 € (im Juli 2019 für nur 7,50 €) erhalten Sie eine trockene, schön aromatische, ausgewogene und außergewöhnliche Weißweincuvée von einem außergewöhnlichen Nahe-Winzer!',
      ],
      media: {
        imgSrc: '/img/wine/weingut-bamberger_vielfalt_2018.png',
      },
      beginCampaign: '2019-07-01T08:00:00.000+02:00',
      endCampaign: '2019-07-31T20:00:00.000+02:00',
      slug: '19-07',
    },
    {
      id: 200004,
      wineId: 100004,
      type: 'wine-of-month',
      active: true,
      price: '5,90',
      discount: '5,40',
      currency: '€',
      description: [
        '',
        'Rosé wird inzwischen von den Verbrauchern berechtigterweise als eigenständiger Weintypus anerkannt. So stieg der weltweite Rosé-Konsum zwischen 2002 und 2015 um erstaunliche 30%!',
        'Eine Modeerscheinung bei Rosé ist die immer heller werdende Farbe. Die Hersteller meinen, dass ein sehr blasses Rosé den Kunden Leichtigkeit und Frische signalisiert. Folgen sie nicht der Mode! Verlassen sie sich auf ihren Geschmack! Auch der tieffarbene Rosé kann leicht und frisch sein!',
        'Unser Rosé vom Staatsweingut Weinsberg stammt von Grundweinen der Rebsorten Lemberger und Spätburgunder. Er füllt das Glas mit klarem, hellem Lachsrot. Sein Bukett ist ausgeprägt und intensiv, es dominieren die Fruchtaromen wie Erd- und Himbeeren und eine angenehme Zitrusnote.',
        'Im Mund wirkt er dank geringer Säure- und Tanninwerte weich, rund und voll. Die Intensität des Fruchtgeschmackes ist recht hoch und er hat einen mittellangen Abgang! Für 5,90 € (Im August für nur 5,40 €) bekommen in diesem Monat einen säurearmen, fruchtbetonten Rosé mit Nachhaltigkeit!',
      ],
      media: {
        imgSrc: '/img/wine/staatsweingut-weinsberg_cuvee-rose_2018.png',
      },
      beginCampaign: '2019-08-01T08:00:00.000+02:00',
      endCampaign: '2019-08-31T20:00:00.000+02:00',
      slug: '19-08',
    },
    {
      id: 200005,
      wineId: 100005,
      type: 'wine-of-month',
      active: true,
      price: '8,00',
      discount: '7,50',
      currency: '€',
      description: [
        '',
        'Unsere elegante norditalienische Rotwein-Cuvée Inauris 2015, der Name bedeutet "in Gold", siehe auch das goldene Etikett, entstand aus den autochthonen Rebsorten Corvina und Corvinone und den internationalen- oder auch Bordeaux-Rebsorten Merlot und Cabernet Sauvignon. Hinzu kommen noch prägend die Einflüsse des sehr guten Jahrgangs 2015 und eine Holzfasslagerung.',
        'Im Glas zeigt der Inauris eine wunderbar strahlende, rubinrote Farbe. Sein Bukett ist dicht, vielschichtig, sehr komplex. Im Vordergrund stehen die Aromen von roten Beeren und Waldbeeren, dahinter kommen feinwürzige Noten und ein Hauch Bitterschokolade. Der Wein ist feingliedrig, mittelgewichtig und erfreut mit sehr langem Abgang.',
        'Sie bekommen in diesem Monat eine feingliedrige, vielschichtige und nachhaltige Rotweincuvée aus einem sehr guten Jahr zu einem günstigen Preis!',
        'Die ideale Serviertemperatur für den Inauris ist 16° C. Er harmoniert großartig mit Grillgerichten, Wild, Rinderbraten und im Geschmack ausgeprägten Käsen.',
      ],
      media: {
        imgSrc: '/img/wine/casa-vinicola-sartori_inauris_2015.png',
      },
      beginCampaign: '2019-09-01T08:00:00.000+02:00',
      endCampaign: '2019-09-30T20:00:00.000+02:00',
      slug: '19-09',
    },
    {
      id: 200006,
      wineId: 100006,
      type: 'special',
      active: true,
      price: '3,80',
      discount: '',
      currency: '€',
      description: [
        '',
        'Noch einmal zur Erinnerung:',
        'Federweißer ist ein Most, der sich im Stadium der Gärung befindet, natürlich trüb und noch kein fertiger Wein ist. Er hat viele Vitamine, aber wenig Alkohol und ist sehr bekömmlich!',
        '',
        'Bitte stehend transportieren!',
      ],
      media: {
        imgSrc: '/img/feder.jpg',
      },
      beginCampaign: '2019-09-06T08:00:00.000+02:00',
      endCampaign: '2020-09-05T20:00:00.000+02:00',
      slug: 'federweisser',
    },
    {
      id: 200007,
      wineId: 100007,
      type: 'wine-of-month',
      active: true,
      price: '9,90',
      discount: '9,40',
      currency: '€',
      description: [
        '',
        'Unser Tessellae von der Domaine Lafage aus Frankreichs Süden, aus der Nähe von Perpignan hat mit dem Jahrgang 2016 ein neues, schöneres, aussagekräftigeres Etikett bekommen. Der Name, der zu 100% verwendeten Rebsorte Carignan wird deutlich benannt. Aus Carignan werden häufig einfache Weine hergestellt. Nicht im Fall unseres Tessellae! Der Etikett-Zusatz „Vieilles Vignes“ (Alte Reben) bedeutet, dass die Reben im Schnitt älter als 70 Jahre sind.',
        'Alte Reben ergeben extraktreichere Weine. Außerdem erntet die Domaine Lafage nur 20 Hektoliter pro Hektar, bei Landweinen sind sonst 60 – 80 hl / ha üblich, diese Ertragsreduzierung kommt schmeckbar der Qualität des Weines zugute. Seine feine mineralische Note verdankt der Tessellae dem im Süden Frankreichs seltenen Schiefer-Mergel-Boden auf dem er wächst.',
        'Der Tessellae zeigt im Glas ein tiefes, kräftiges und strahlendes Rubinrot. Er duftet intensiv nach reifen Pflaumen, Kirschen und Brombeeren, dahinter folgen Anklänge an Kräutern und Bitterschokolade und eine Spur Mineralität. Im Mund wirkt der Tessellae voll, üppig und rund, er hat keine Ecken und Kanten, ist ausgewogen mit eingebundenen Tanninen und geringer Säure und hat einen schönen, langen Abgang.',
        'Nicht umsonst begeistert uns dieser Wein bereits seit Jahren!',
      ],
      media: {
        imgSrc: '/img/wine/domaine-lafage_tessellae_2017.jpg',
      },
      beginCampaign: '2019-10-01T08:00:00.000+02:00',
      endCampaign: '2019-10-31T20:00:00.000+02:00',
      slug: '19-10',
    },
    {
      id: 200008,
      wineId: 100008,
      type: 'new-wine',
      active: true,
      price: '6,90',
      currency: '€',
      description: [
        '',
        'Unser Riesling Peterhoff ist hellfarbig strohgelb und duftet angenehm nach grünen Äpfeln und Fruchtdrops. Typisch für den Rheingau ist auch eine klare Mineralik. Im Mund spürt man eine feine, spritzige Säure, die den Wein besonders frisch wirken lässt.',
        '',
        'Diesen erfrischenden Riesling aus dem Rheingau lassen wir extra für unsere Einkaufsgemeinschaft von 40 Weinhändlern aus ganz Deutschland bei der Villa Gutenberg abfüllen. Durch die gemein-sam eingekaufte große Menge können wir Ihnen diesen wunderbaren, trockenen, leichten Kabinettwein zu einem besonders günstigen Preis anbieten.',
        '',
      ],
      media: {
        imgSrc: '/img/wine/peterhoff_riesling-kabinett_2018.jpg',
      },
      beginCampaign: '2019-10-01T08:00:00.000+02:00',
      endCampaign: '2019-10-31T20:00:00.000+02:00',
      slug: 'peterhoff-riesling-2018',
    },
    {
      id: 200009,
      wineId: 100009,
      type: 'wine-of-month',
      active: true,
      price: '13,90',
      discount: '13,00',
      currency: '€',
      description: [
        '',
        'Unser Wein dieses Monats kommt aus Südfrankreich aus der näheren Umgebung der berühmten Burg-Stadt Carcassonne und wird aus 4 Rebsorten mit folgender Zusammensetzung erzeugt: 40 % Merlot, 30 % Syrah, 20 % Cabernet Sauvignon und 10% Grenache. Das ist ein für die Gegend typischer "Bordeaux trifft Midi-Stil"! Abgerundet wird das Ganze durch einen moderaten Ausbau in kleinen (225 L) französischen Eichenfässern. Das Ergebnis scheint uns wunderbar gut gelungen!',
        'Übrigens: "Terroirs de Altitude" bezeichnet die Höhenlagen (von 360 m ü.M.) auf denen die Reben für diesen Wein wachsen. Die nächtliche Abkühlung auf dieser Höhe sorgt für die Bildung von ausgeprägten und frischen Fruchtaromen in den Trauben. Und das kann man auch schmecken!',
        'Unser Wein zeigt ein tiefes, dunkles Granatrot; die Nase wird erfreut durch eine vielschichtige Aromatik nach Blaubeeren, Cassis, schwarzen Oliven, Gewürzen und dahinter zarten Noten von Räucherspeck und Leder. Im Mund wirkt er trocken, hat seidige Tannine - die Einflüsse des Barriqueausbaus sind aber deutlich - hat einen vollen Körper und ist sehr nachhaltig!',
        'Sie erhalten in diesem Monat einen komplexen Wein mit viel Kraft, Finesse und Eleganz für die Feiertage am Jahresende!',
      ],
      media: {
        imgSrc: '/img/wine/vignobles-lorgeril_chateau-de-pennautier_2014.jpg',
      },
      beginCampaign: '2019-11-01T08:00:00.000+02:00',
      endCampaign: '2019-11-30T20:00:00.000+02:00',
      slug: '19-11',
    },
    {
      id: 200010,
      wineId: 100010,
      type: 'wine-of-month',
      active: true,
      price: '14,90',
      discount: '14,00',
      currency: '€',
      description: [
        '',
        'Unser neuer Crémant Comtesse de Saint-Pey kommt aus dem Entre-deux-mers-Gebiet, der größten weinerzeugenden Region des Bordeaux. Er wird aus der einheimischen weißen Rebsorte Semillion (zu 70%) und aus der einheimischen roten Rebsorte Cabernet Franc (zu 30%) gekeltert. Diese Mischung bestimmt seinen einzigartigen, unverwechselbaren Charakter! Mit allen Crémants hat er aber die zweite Gärung auf der Flasche gemein, bei der die berauschenden, kleinen, emsig aufsteigenden CO2-Perlchen entstehen. Dieses Schaumwein-Herstellungsverfahren nennt man heute méthode traditionnelle, früher méthode champenoise (Champagnerverfahren).',
        'Im Glas funkelt die Comtesse de Saint-Pey in hellem, strahlendem Strohgelb. Sie erfreut unsere Nase mit vielschichtigen Aromen nach Brioche, Hefe, Grapefruit, reifen Äpfeln, Quitten und einem Hauch weißer Blüten. Im Mund wirkt sie wunderbar erfrischend dank ihrer mundfüllenden, cremig-feinen und stetigen Perlage und ihrer Leichtigkeit (nur 12% Vol.). Dabei ist sie von hoher Geschmacksintensität und schließt mit einem langen Nachhall.',
        'Wir bieten Ihnen im Dezember einen leichten, aber intensiven Crémant – so wie er sein sollte - mit kräftiger, ausdauernder Perlage und lang anhaltendem Nachgeschmack! Und schließen uns vollständig der Kürzestbeschreibung des Herstellers an: "… elegant, delikat, raffiniert …"!',
      ],
      media: {
        imgSrc: '/img/wine/prodiffu-landerrouat_comtesse-de-saint-pey_2017.png',
      },
      beginCampaign: '2019-12-01T08:00:00.000+02:00',
      endCampaign: '2019-12-31T20:00:00.000+02:00',
      links: [
        {
          name: '[Weinwissen: Die Geschmacksabstufungen beim Sekt nach Restzucker]',
          uri: '/l/wissen-sekt',
        },
      ],
      slug: '19-12',
    },
    {
      id: 200011,
      wineId: 100011,
      active: true,
      type: 'wine-of-month',
      price: '6,30',
      discount: '5,80',
      currency: '€',
      description: [
        'Unser Castillo de Almansa Roble wird in der Provinz Albacete in Kastilien-La Mancha im südöstlichen Spanien erzeugt. Er entsteht in der renommierten Bodega Piqueras der Familie Bonete zu je 50% aus den Rebsorten Monastrell und Garnacha tintorera. Der Begriff „Roble“ gibt an, dass der Wein nach Fertigstellung 3 – 4 Monate in einem 300 Liter-Eichenfass gereift wurde. Und übrigens: das Bild auf dem Etikett zeigt tatsächlich das historische Castillo de Almansa.',
        'Die Farbe des Castillo de Almansa Roble ist ein schönes, sehr tiefes Kirschrot mit leichten violetten Reflexen. In die Nase steigt uns ein sanftes Bukett nach reifen Kirschen und schwarzen Beeren, dahinter Anklänge vom Eichenfassausbau: Leder, Kakao und Kaffee. Alles ist gut eigebunden – der Wein ist harmonisch!',
        'Im Mund wirkt er trocken, ist mittelkräftig mit einem intensiven, langen Abgang. Er hat viel Charakter, dank niedriger Säurewerte und reifer Tannine ist er wunderbar sanft und samtig. Wir empfehlen ihn bei 16° zu trinken!',
        '',
        'Der Wein ist - im Monat Januar - für nur 5,80 € ein grandioses Schnäppchen!!!',
      ],
      media: {
        imgSrc: '/img/wine/bodegas-piqueras_castillo-de-almansa-roble_2016.png',
      },
      beginCampaign: '2020-01-01T08:00:00.000+02:00',
      endCampaign: '2020-01-30T20:00:00.000+02:00',
      slug: '20-01',
    },
    {
      id: 200012,
      wineId: 100012,
      type: 'wine-of-month',
      active: true,
      price: '7,30',
      discount: '6,50',
      currency: '€',
      description: [
        '',
        'Unser 2019er Novello Veneto IGT stammt aus Valdobbiadene im nördlichen Venezien, dem Stammland des Prosecco, von einem der bekanntesten und besten Prosecco-Erzeuger: der Tenuta Villa Sandi. Dieser junge Wein wurde aus den beiden kräftigen Bordeaux-Reben Cabernet Franc und Cabernet Sauvignon gekeltert.',
        'Es ist ein jugendlicher, frischer Wein, der als einer der ersten des Jahres auf Flaschen gefüllt wird, ist aber trotzdem schon trinkfertig und besticht mit tollen Fruchtnoten, recht geringem Alkoholgehalt (11,5 %) und wenigen weichen Tanninen. Er kann und sollte leicht gekühlt bei 14 – 16 ° getrunken werden.',
        '',
        'Mit diesem jungen, fruchtig-erfrischenden Wein aus dem Veneto wird der neue Weinjahrgang 2019 eingeläutet!',
      ],
      media: {
        imgSrc: '/img/wine/villa-sandi_novello_2019.png',
      },
      beginCampaign: '2020-02-01T08:00:00.000+02:00',
      endCampaign: '2020-02-29T20:00:00.000+02:00',
      slug: '20-02',
    },
    {
      id: 200013,
      wineId: 100013,
      type: 'wine-of-month',
      active: true,
      price: '9,60',
      discount: '9,00',
      currency: '€',
      description: [
        '',
        'Das 15 Hektar große Weingut Toni Jost Hahnenhof aus Bacharach wird von Vater Peter und Tochter Cecilia Jost gemeinsam geführt. Das Weingut besitzt Weinberge in den beiden Weinbaugebieten Rheingau und Mittelrhein und ist Mitglied im VdP (Verband Deutscher Prädikats- und Qualitätsweingüter), er-kennbar am VdP "Traubenadler" auf der Kapsel oder dem Schraubverschluss jeder Flasche.',
        'Es ist ein jugendlicher, frischer Wein, der als einer der ersten des Jahres auf Flaschen gefüllt wird, ist aber trotzdem schon trinkfertig und besticht mit tollen Fruchtnoten, recht geringem Alkoholgehalt (11,5 %) und wenigen weichen Tanninen. Er kann und sollte leicht gekühlt bei 14 – 16 ° getrunken werden.',
        '',
        'Mit diesem jungen, fruchtig-erfrischenden Wein aus dem Veneto wird der neue Weinjahrgang 2019 eingeläutet!',
      ],
      media: {
        imgSrc: '/img/wine/weingut-toni_jodocus_2017.png',
      },
      beginCampaign: '2020-03-01T08:00:00.000+02:00',
      endCampaign: '2020-03-31T20:00:00.000+02:00',
      slug: '20-03',
    },
    {
      id: 200014,
      wineId: null,
      wineIds: [100014, 100015],
      type: 'wine-of-month',
      active: true,
      prices: ['9,30', '9,30'],
      discounts: ['8,80', '8,80'],
      currency: '€',
      description: [
        '',
        'Das 58 Hektar große Weingut Dürnberg befindet sich im traditionsreichen Weinort Falkenstein, dem historischen Herzen des Weinviertels in Niederösterreich. Seit dem 12. Jahrhundert ist der Weinbau hier belegt. Unsere beiden Weine zeigen deutlich, dass der Weinbau hier im Laufe der Zeit einen sehr hohen Qualitätsstand erreicht hat!',
        '',
      ],
      detailDescriptions: [
        [
          'Grüner Veltliner Falkenstein, Weinviertel DAC, der Klassiker der Region präsentiert ein helles Strohgelb, riecht nach frischer, grüner Apfelfrucht und Zitrusfrüchten außerdem Anklänge an weißen Pfeffer, alles ergänzt durch feine mineralische Noten. Übrigens: eine Befragung von Sommeliers hat ergeben, dass sie in ihrer Mehrzahl den Grünen Veltliner für den passenden Wein zu Spargelgerichten halten! Also: Unbedingt probieren!',
        ],
        [
          'Unsere Cuvée Falko ist eine wunderbar gelungene Verbindung aus den Rebsorten Muskateller, Welschriesling und ein wenig Sauvignon Blanc. Aus dem Glas steigt ein intensives, komplexes Bukett von Flieder- und Holunderblüten unterlegt mit Fruchtaromen von Quitte und Mandarine. Im Mund wirkt er angenehm frisch bei milder Säure und erfreut im Abgang mit einer schönen Länge. Eine gute Wahl für gesellige Stunden! Und Falko macht Lust auf ein zweites Glas!',
        ],
      ],
      media: [
        {
          imgSrc: '/img/wine/weingut-durnberg_veltliner_2019.jpg',
        },
        {
          imgSrc: '/img/wine/weingut-durnberg_falko_2019.jpg',
        },
      ],
      beginCampaign: '2020-04-01T08:00:00.000+02:00',
      endCampaign: '2020-04-30T20:00:00.000+02:00',
      slug: '20-04',
    },
    {
      id: 200015,
      wineId: 100016,
      type: 'wine-of-month',
      active: true,
      price: '7,90',
      discount: '7,40',
      currency: '€',
      description: [
        '',
        'Die Weinberge des 15 Hektar großen Weingutes Friedrich Altenkirch in Lorch haben eine glückliche Lage. Die Reben wachsen oberhalb des Rheins auf einem einzigartigen Terroir, auf mineralischem Schieferboden, und durch die bis zu 60 Grad steile Hanglage in Kombination mit der hohen Sonneneinstrahlung des Rheingaus sind beste Voraussetzungen für die Erzeugung von Spitzenweinen gegeben. Erkauft wird diese gute Qualität durch extreme Anstrengungen, so werden die Trauben in der Steillage zu 100% von der Hand gelesen!',
        'Die goldgelbe Cuvée Boogie 2019 ist eine gekonnte Verbindung aus den verwen-deten Rebsorten Weißburgunder, Riesling, Sauvignon blanc, Scheurebe und Ri-vaner. Vielfältig wie die Rebauswahl fallen dann auch die Aromen im Wein aus. Im Vordergrund steht eine deutliche, frische Zitrusfruchtnote, begleitet von ei-nem herrlichen Duft nach grünem Apfel, dahinter noch ein Hauch von Pfirsich und eine Spur Mineralität. Das alles bei einer sehr dezenten Restsüße, die die Fruchtaromen noch unterstützt, und einer angenehmen Leichtigkeit, unser Boo-gie hat nur 12 % Volumen Alkohol.',
        'Wir bieten Ihnen im Mai einen leichten, fruchtbetonten und harmonischen Wein aus dem Rheingau – nicht nur – für schöne Sommertage!',
        'Achtung: die im Boogie verwendeten Rebsorten werden - bis auf den Riesling - im Weingut Altenkirch nur auf kleiner Fläche angebaut, deshalb ist der Boogie leider meist schon früh im Jahr ausgetrunken!',
      ],
      media: {
        imgSrc: '/img/wine/weingut-altenkirch_boogie_2019.png',
      },
      beginCampaign: '2020-05-01T08:00:00.000+02:00',
      endCampaign: '2020-05-31T20:00:00.000+02:00',
      slug: '20-05',
    },
    {
      id: 200016,
      wineId: 100017,
      type: 'wine-of-month',
      active: true,
      price: '6,00',
      discount: '5,50',
      currency: '€',
      description: [
        '',
        'Bitte beachten: Ein bemerkenswert hübsches Detail bei diesem Wein ist das Etikett. Hier ist den Vignerons de Berticot der Versuch gelungen, die beschwingte Leichtigkeit ihres Weines sinnbildlich darzustellen!',
        'Unser Landwein Le Petit Berticot Sauvignon IGP strahlt hell-strohgelb im Glas. Der Sauvignon ist eine aromatische Rebe und deshalb erfasst unsere Nase einen intensiven sauberen Duft nach frisch gemähtem Gras, nach grünem Apfel und Noten von Zitrusfrucht.',
        'Alles sehr angenehm und recht typisch für einen leichten, frischen Sauvignon mit nur 12 % Volumen Alkohol. Im Mund ist Le Petit Berticot Sauvignon weich und rund mit feinem Säurespiel und endet schön mit mittlerer Länge.',
        'Sie bekommen in diesem Monat puren Trinkgenuss in Form eines leichten, frischen, fruchtigen französischen Landweins des aktuellen Jahrgangs! Wohl bekomm´s!',
      ],
      media: {
        imgSrc: '/img/wine/berticot_le-petit_2019.jpg',
      },
      beginCampaign: '2020-06-01T08:00:00.000+02:00',
      endCampaign: '2020-06-30T20:00:00.000+02:00',
      slug: '20-06',
    },
    {
      id: 200017,
      wineId: 100018,
      type: 'wine-of-month',
      active: true,
      price: '7,30',
      discount: '6,80',
      currency: '€',
      description: [
        '',
        'Das Weingut Heitlinger liegt südlich von Heidelberg im idyllischen Kraichgau in Baden und ist mit seinen 80 Hektar Anbaufläche eins der größten ökologisch arbeitenden Weingüter Deutschlands. Außerdem ist das Weingut Mitglied im renommierten VdP (Verband Deutscher Prädikats- und Qualitätsweingüter), erkennbar am VdP- "Traubenadler" auf der Kapsel oder dem Schraubverschluss jeder Flasche. Mit 4 von 5 Trauben im führenden deutschen Weinführer Gault & Millau zählt das VDP-Gut zu Badens Top-Erzeugern und „macht den Sprung an die deutsche Spitze“, zeigt sich jedenfalls Gault & Millau überzeugt.',
        'Der Heitlinger Rosé 2019 ist eine gelungene Cuvée aus den Rebsorten Pinot Noir (Spätburgunder) und Pinot Meunier (Schwarzriesling) und zeigt im Glas ein herrliches, helles Kirschrot. Er duftet kräftig nach roten Beeren wie Erd- und Himbeeren und hat in der Nase süßliche Noten nach Fruchtdrops und Karamell. Im Mund ist er dann frisch, fruchtig und belebend – auch durch seine leichte, gelöste Kohlensäure – ist dabei durchaus kräftig im Geschmack, mittelgewichtig und hat einen erfreulich langen Abgang',
        '',
        'Das alles bei nur 11% Volumen Alkohol! Sehr charmant!',
      ],
      media: {
        imgSrc: '/img/wine/weingut-heitlinger_rose_2019.png',
      },
      beginCampaign: '2020-07-01T08:00:00.000+02:00',
      endCampaign: '2020-07-31T20:00:00.000+02:00',
      slug: '20-07',
    },

    {
      id: 200018,
      wineId: 100019,
      type: 'wine-of-month',
      active: true,
      price: '6,90',
      discount: '6,40',
      currency: '€',
      description: [
        '',
        'Unser trockener Riesling Peterhoff aus dem Rheingau des neuen Jahrgangs 2019 ist hellfarbig strohgelb und duftet angenehm nach Zitronen, grünen Äpfeln und Fruchtdrops. Typisch für den Rheingau ist auch seine deutliche Mineralik. Im Mund spürt man seine feine, spritzige, aber nicht aggressive, Säure, die den Wein angenehm frisch wirken lässt.',
        '',
        'Diesen erfrischenden Riesling aus dem Rheingau lassen wir extra für unsere Einkaufsgemeinschaft von 40 kleinen selbständigen Weinhändlern aus ganz Deutschland bei der Villa Gutenberg abfül-len. Durch die gemeinsam eingekaufte große Menge können wir Ihnen diesen wunderbaren, trockenen, leichten Kabinettwein zum gleich günstigen Preis wie im letzten Jahr anbieten!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/peterhoff_riesling-kabinett_2018.jpg',
      },
      beginCampaign: '2020-08-01T08:00:00.000+02:00',
      endCampaign: '2020-08-30T20:00:00.000+02:00',
      slug: '20-08',
    },
    {
      id: 200019,
      wineId: 100020,
      type: 'wine-of-month',
      active: true,
      price: '9,50',
      discount: '9,00',
      currency: '€',
      description: [
        '',
        'Das Wahrzeichen von Villa Sandi ist die historische Villa, erbaut 1622 als Sommerresidenz der venezianischen Familie Sandi. Sie ist nicht nur der Sitz des gleichnamigen Weingutes in Valdobbia-dene, dem Kerngebiet des Prosecco, sondern sie ziert das Eti-kett jeder Flasche des Weingutes. Die Weinberge erstrecken sich über die bekanntesten DOC und DOCG-Gebiete Venetiens. 2019 wurden die Weinberge des Valdobbiadene zum UNESCO Weltkulturerbe ernannt.',
        'Villa Sandi produziert Prosecchi und Sekte nach der Martinotti Charmat Methode. Die moderne Kellertechnik und die Kühlung des Mostes ermöglichen die Konservierung der natürlichen Frucht der Trauben. Dies kommt deutlich schmeckbar der Quali-tät unseres Rosé Sektes »Il Fresco« aus den Rebsorten Glera, Chardonnay, Pinot Nero zugute.',
        'Mundus Vini 2019: Silber; Wine Spectator: Top 100 Values. Er zeigt sich zart lachsfarben mit einer langanhaltenden, feinen Perlage. Seine sanfte Fruchtnote aus Erd- und Himbeeren sowie Rosen- und Hagebuttenblüten werden von einem ausgewoge-nen Süße-Säure-Spiel abgerundet. Perfekt als Aperitif oder mit Meeresfrüchten oder asiatischen Gerichten!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/villa-sandi_rose_ilfresco.png',
      },
      beginCampaign: '2020-09-01T08:00:00.000+02:00',
      endCampaign: '2020-09-30T20:00:00.000+02:00',
      slug: '20-09',
    },
    {
      id: 200020,
      wineId: 100021,
      type: 'new-wine',
      active: true,
      price: '9,00',
      currency: '€',
      description: [
        '',
        'Endlich ist wieder eine rebsortenreine Scheurebe im Sortiment! Von vielen lang erwartet – soeben eingetroffen! Seien Sie nicht scheu, fragen Sie nach einem Probeschluck! Es lohnt sich! Die Scheurebe ist eine weiße Rebsorte mit viel aromatischer Ähnlichkeit zum Sauvignon Blanc. Die Rebsorte wurde 1916 von Georg Scheu in Alzey gezüchtet. Er ging davon aus, dass die beiden Rebsorten Riesling und Silvaner die Eltern seien. 2012 widerlegten Wissenschaftler dies durch DNA-Analysen. Die Kreuzungspartner waren demnach der Riesling und die Bukett-rebe, die wiederum eine Kreuzung aus Silvaner und Trollinger ist.',
        'Im Glas zeigt unsere Scheurebe ein glänzendes, helles Stroh-gelb mit zarten grünlichen Reflexen. Das deutsche Weininstitut schrieb einmal: "Scheurebe – ihrem Duft kann man sich schwer entziehen!" Richtig: wir entdecken eine Vielfalt an Aromen von schwarzen Johannisbeeren (Cassis), Stachelbeeren, Grapefruit, aber auch von exotischen Früchten wie Mango und Maracuja. Im Mund wirkt die Scheurebe relativ leicht, sie erfreut durch ih-re animierende Säure und einen mittellangen Abgang! Es bleibt dabei: man kann sich dieser Scheurebe nur schwer entziehen!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/weingut-bamberger_scheurebe_2019.png',
      },
      beginCampaign: '2020-07-01T08:00:00.000+02:00',
      endCampaign: '2020-07-31T20:00:00.000+02:00',
      slug: 'weingut-bamberger-scheurebe-2019',
    },
    {
      id: 200021,
      wineId: 100022,
      type: 'new-wine',
      active: true,
      price: '8,90',
      currency: '€',
      description: [
        '',
        'Pinot Noir steht auf dem Etikett, also ist ein deutscher Spät-burgunder in der Flasche. Charakteristisch für diese deutsche, rote Leitrebe ist das helle, strahlende Rubinrot des Weines und sein typisches Bukett mit deutlichen Aromen nach roten und schwarzen Beeren, etwas Minze, frischen Kräutern und einer de-zenten Holznote. Im Mund wirkt der Wein recht weich und rund, ist elegant strukturiert und dabei mittelgewichtig bei nur 12,5 % Alkohol. Er hat spürbare, aber runde, weiche Tannine und ist mittellang im Abgang!',
        'Probieren Sie den Pinot Noir 2018 doch einmal zu Lammloins oder einen Rehrücken!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/weingut-gaul_pinot-noir_2018.png',
      },
      beginCampaign: '2020-08-01T08:00:00.000+02:00',
      endCampaign: '2020-08-30T20:00:00.000+02:00',
      slug: 'weingut-gaul-pinot-noir-2018',
    },
    {
      id: 200022,
      wineId: 100023,
      type: 'wine-of-month',
      active: true,
      price: '9,90',
      discount: '9,50',
      currency: '€',
      description: [
        '',
        'Unser Traluna ist ein Landwein aus der Toscana. Das 37 Ha grosse historische Weingut Villa Trasqua liegt zwischen Siena und Monteviggioni. Deshalb besteht seine Cuvée auch zu 70% aus der Chianti-Leitrebe Sangiovese, zu gleichen Teilen ergänzt durch die internationalen Reben Cabernet Sau-vignon und Merlot. Diese Zusammenstellung ist sehr gelungen!',
        'Der Wein zeigt ein schönes mitteltieffarbiges Rubinrot und besticht in der Nase durch fruchtige Noten von Waldbeeren und dunklen Kirschen mit einer feinen Note nach Gewürzen. Im Mund ist er ausgewogen, ohne Ecken und Kanten, mit weichen Tanninen, süßlichen Noten und einem anhaltenden Nachgang. Wir empfehlen als Trinktemperatur 14° bis 16°C.',
        'Die Kombinationsmöglichkeiten zum Essen sind vielfältig: probieren sie ihn zu rotem Fleisch oder Spaghetti Bolognese!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/villa-trasqua_traluna_2018.png',
      },
      beginCampaign: '2020-10-01T08:00:00.000+02:00',
      endCampaign: '2020-10-31T20:00:00.000+02:00',
      slug: '20-10',
    },
    {
      id: 200023,
      wineId: 100024,
      type: 'wine-of-month',
      active: true,
      price: '17,90',
      discount: '16,50',
      currency: '€',
      description: [
        '',
        'Bitte nicht verwechseln: bei einem Vino Nobile di Montepulciano handelt es sich um einen Wein aus dem Städtchen Montepulciano im Süden der Tos-kana und nicht um einen Wein aus der Rebsorte Montepulciano!',
        'Unser Vino Nobile besticht durch ein schönes, mitteltiefes Rubinrot, er duftet intensiv nach Sauerkirschen und Bombeeren mit einer zarten Unternote nach Pfeffer. Unverkennbar sind auch die Töne vom Holzfass, Röstaromen nach Kaffee und Kakao.',
        'Der Wein der Fattoria Talosa ist charaktervoll und kräftig, dabei aber fein und elegant. Sein Abgang ist langanhaltend, die Tannine sind relativ weich, die Weinsäure liegt für die Rebsorte Sangiovese im unteren Bereich. Der Wein ist ein typischer Toskana-Sangiovese mit Bariqueausbau und kann noch einige Jahre gelagert werden.',
        '',
      ],
      media: {
        imgSrc: '/img/wine/fattoria-della-talosa_vino-nobile_2014.png',
      },
      beginCampaign: '2020-11-01T08:00:00.000+02:00',
      endCampaign: '2020-11-30T20:00:00.000+02:00',
      slug: '20-11',
    },
    {
      id: 200024,
      wineId: 100025,
      type: 'wine-of-month',
      active: true,
      price: '15,50',
      discount: '14,50',
      currency: '€',
      description: [
        '',
        'Der bekannte Weinführer "Der kleine Johnson" lobt die Sektmanufaktur Schloss Vaux als "überragenden Sekthersteller".',
        'Die Geschichte von Schloss Vaux begann mit der Gründung 1868 in Berlin! Es wurde das Château Vaux nebst Weinbergen in der Nähe von Metz gekauft und dort stellte man dann 40 Jahre deutschen Sekt her. Mittlerweile residiert Schloss Vaux in Eltville im Rheingau und widmet sich der Herstellung von Spitzensekte aus Rheingauweinen nach der traditionellen Methode in klassischer Flaschengärung.',
        'Unsere Sekt-Cuvée Brut der Sektmanufaktur Schloss Vaux entsteht aus den Rebsorten Weißburgunder, weißgekeltertem Spätburgunder und Riesling und bleibt 21 Monate auf dem Hefelager! Ihre Farbe ist ein zar-tes, helles Strohgelb und sie hat eine feine und stetige Perlage. Unsere Nase entdeckt fruchtig-frische Aromen nach Zitrusfrüchten, Äpfeln, Ap-rikosen und Melonen. Am Gaumen erleben wir die erfrischende Säure des Rieslings, die Fülle und den cremigen Schmelz der Burgunderrebsorten. Zum Schluss er-freut uns ein Nachhall mit schöner Länge.',
        'Ich fand im Internet einen Spruch, der wunderbar die Qualität der Sekte von Schloss Vaux auf den Punkt bringt: Schloss Vaux ist "…Sekt für Leu-te, die es sich leisten können, keinen Champagner zu trinken!"',
      ],
      media: {
        imgSrc: '/img/wine/schloss-vaux_cuvee-brut.png',
      },
      beginCampaign: '2020-12-01T08:00:00.000+02:00',
      endCampaign: '2020-12-31T20:00:00.000+02:00',
      slug: '20-12',
    },
    {
      id: 200025,
      wineId: 100026,
      type: 'wine-of-month',
      active: true,
      price: '8,10',
      discount: '7,50',
      currency: '€',
      description: [
        '',
        'Unser Wein des Monats im Januar 2021 kommt aus Chusclan, aus dem südlichen Rhône-Tal, der Region unterhalb von Lyon, zwischen Vienne und Avignon. Hier herrschen sowohl klimatisch als auch geologisch extrem gute Bedingungen für den Weinanbau. Die Römer haben deshalb dort bereits vor 2000 Jahren Wein angebaut!',
        'Unser Côtes du Rhône Prieurs de St. Julien 2018 in der 1-Liter Flasche ist eine Cuvée von Weinen aus den Rebsorten Grenache Noir (70%), Carignan, Syrah und Cinsault. Eine klassich-charakteristische Rhône-Mischung, die sich auch im Geschmack widerspiegelt! Der Wein zeigt im Glas ein tiefes, brilliantes Rubinrot. In der Nase dominiert ein schönes Bouqet nach Erd- und Himbeeren, dahinter ein Hauch von getrockneten Pflaumen und eine zarte Pfeffernote. Im Mund wirkt der Côtes du Rhône ansprechend weich, seidig, unkompliziert und vollmundig. Die Qualität dieses Weines erreicht das Niveau vieler höher bewerteter Côtes du Rhône Villages und hat zu recht seine Goldmedallie verdient!',
        'Der Prieurs de St. Julien ist ein guter Begleiter von gebratenem oder gegrilltem Rindfleisch oder Lamm und Wild (Hirsch).',
        '',
      ],
      media: {
        imgSrc: '/img/wine/chusclan_st-julien_2018.png',
      },
      beginCampaign: '2021-01-01T08:00:00.000+02:00',
      endCampaign: '2021-01-31T20:00:00.000+02:00',
      slug: '21-01',
    },
    {
      id: 200026,
      wineId: 100027,
      type: 'wine-of-month',
      active: true,
      price: '8,50',
      discount: '8,00',
      currency: '€',
      description: [
        '',
        'Die Rebsorte Primitivo wird überwiegend an sonnenverwöhnten Weinbergen in Süditalien angebaut. In der Gegend ist sie eine der wichtigsten Rotweinsorten.',
        '',
        'Für unseren Primitivo IGT wurden die frisch gelesenen, gesunden Trauben für eine bestimmte Zeit angetrocknet (rosiniert). Durch diese Methode (italienisch: Appassimento) wird den Trauben Flüssigkeit entzogen. Säure, natürlicher Fruchtzucker und andere geschmacksbildende Extraktstoffe bleiben aber in erhöhter Konzentration im Most erhalten. So erhält man komplexe, vollmundige und kraftvolle Weine.',
        '',
        'Der Linteo Primitivo zeigt ein tieffarbiges Granatrot und duftet komplex nach gekochtem Steinobst, Süßholz, Kräutern und Gewürzen. Im Mund wirkt er weich, körperreich, rund und konzentriert mit gut eingebundenen weichen Tanninen, wenig Säure und langem Nachhall. Der Linteo Primitivo passt gut zu dunklem Fleisch und kräftigem Käse.',
        '',
      ],
      media: {
        imgSrc: '/img/wine/linteo-primitivo_cantine-minini_2019.png',
      },
      beginCampaign: '2021-02-01T08:00:00.000+02:00',
      endCampaign: '2021-02-28T20:00:00.000+02:00',
      slug: '21-02',
    },
    {
      id: 200027,
      wineId: 100028,
      type: 'wine-of-month',
      active: true,
      price: '7,50',
      discount: '7,00',
      currency: '€',
      description: [
        '',
        'Das 16,5 Hektar große familiengeführte Weingut Kühling liegt am südlichen Rand von Rheinhessen und bewirtschaftet seine Weinberge seit 2007 kontrolliert ökologisch nach den strengen Regelndes Verbandes Naturland e.V. Für die Zeitschrift "Der Feinschmecker" zählt das Weingut zu den besten 500 Weingütern Deutschlands!',
        'Der Saint Laurent gehört zur Familie der Burgunder-Rebsorten. Er war in den 50er Jahren fast ausgerottet. Mit der Renaissance des Rotweins in Deutschland Ende des 20. Jahrhunderts kam auch diese alte Rebsorte zu neuen Ehren. Im Jahr 2014 waren schon 0,6% der Rebfläche in Deutschland mit dieser Rarität und Spezialität bepflanzt.',
        'Unser Saint Laurent zeigt im Glas die typisch dunkele Farbe, ein tiefes Granatrot mit violetten Reflexen. In die Nase steigen fruchtbetonte Aromen nach Brombeeren, Pflaumen und schwarzen Kirschen. Im Mund ist er frisch, mittelgewichtig und erfreut mit seidigen Tanninen. Den Abschluss bildet ein gut mittellanger Abgang. Mit diesem Wein kann man sehr gut Vorurteile gegen deutsche Rotweine abbauen!',
        '',
        'Neben dem Saint Laurent führen wir außerdem vom Bio-Weingut Kühling einen Weißburgunder, einen Chardonnay, einen Muscaris (Orange wine, ungefiltert) und den wunderbaren Gelben Muskateller!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/weingut-kuhling_st-laurent_2018.png',
      },
      beginCampaign: '2021-03-01T08:00:00.000+02:00',
      endCampaign: '2021-03-31T20:00:00.000+02:00',
      slug: '21-03',
    },
    {
      id: 200028,
      wineId: null,
      wineIds: [100029, 100030, 100031],
      type: 'wine-of-month',
      active: true,
      prices: ['4,90'],
      discounts: ['4,50'],
      onePrice: true,
      currency: '€',
      description: [
        '',
        'Die Bodegas Cristo de la Vega liegt unweit von Ciudad Real im Herzen von La Mancha, dem weltweit größten zusammenhängenden Weinanbaugebiet. Der Weinanbau ist dort die wichtigste wirtschaftliche Aktivität der Menschen. Bei der quantitativ gewaltigen Menge erzeugten Weines stellt sich natürlich die Frage nach der Qualität. Die Genossenschaft Cristo de la Vega ist technisch auf dem neuesten Stand und produziert Weine aus nationalen und internationalen Rebsorten von höchster Qualität! Probieren Sie die Weine doch einfach selbst! Neben den 3 beschriebenen Weinen führen wir außerdem eine Crianza und Réserva Marqués de Castilla von Bodegas Cristo de la Vega.',
        '',
      ],
      detailDescriptions: [
        [
          'Rebsortenrein aus Airén hergestellt hat der Blanco 2020 eine strahlend stroh-gelbe Farbe, in die Nase steigen zarte exotische Fruchtnoten von Banane und Ananas, im Mund wirkt er trocken, frisch mit ausgewogener Säure und ange-nehmen Nachhall. Bei 7 – 8° trinken!',
        ],
        [
          'Roséwein aus den Rebsorten Garnacha und Tempranillo. Er begeistert durch seine wunderbare Farbe: ein helles, intensiv strahlendes Kirschrot! In der Nase präsentiert er Aromen von Himbeeren, Erdbeeren und Johannis-beeren. Am Gaumen ist er sehr präsent und lebendig, frisch, aber mit dezenter Säure und zarten Bitternoten im Abgang. Trinktemperatur 7 – 8°!',
        ],
        [
          'Junger Rotwein aus den Edelrebsorten Tempranillo, Syrah und Merlot. Die Far-be ist ein schönes Granatrot mit violetten Reflexen. In der Nase intensive Aromen nach roten Früchten wie Brombeeren, Johannisbeeren und Pflaumen. Im Mund ist der Tinto ausdrucksstark mit nachhaltigen Fruchtaromen und spürbaren Tanninen bei angenehm langem Finish! Trinken bei 16°!',
        ],
      ],
      media: [
        {
          imgSrc: '/img/wine/marque-de-castilla_blanco_2020.jpg',
        },
        {
          imgSrc: '/img/wine/marque-de-castilla_rosado_2020.jpg',
        },
        {
          imgSrc: '/img/wine/marque-de-castilla_tinto_2020.jpg',
        },
      ],
      beginCampaign: '2021-04-01T08:00:00.000+02:00',
      endCampaign: '2021-04-30T20:00:00.000+02:00',
      slug: '21-04',
    },
    {
      id: 200029,
      wineId: 100032,
      type: 'wine-of-month',
      active: true,
      price: '5,90',
      discount: '5,50',
      currency: '€',
      description: [
        '',
        'Auf dem Jesuitenhof in Dirmstein bei Worms wird bereits seit 1803 Wein gemacht. Klaus und Andrea Schneider gründeten im Jahr 1986 das Weingut in der heutigen Form. Auf 25 ha werden Riesling- und Bur-gunderweine erzeugt. 2011, nach Abschluss seines Önologie-Studiums, ist der Sohn Moritz für die Herstellung der Weine mitverantwortlich. Der Jesuitenhof ist ein familiengeführtes Weingut mit dem Anspruch, au-thentische Pfälzer Weine auf hohem Qualitätsniveau zu erzeugen!',
        'Rivaner ist Müller-Thurgau! Der Wissenschaftler Hermann Müller aus dem Schweizer Kanton Thurgau züchtete 1882 eine Rebsorte, die später nach ihm "Müller-Thurgau“ be-nannt wurde. In der Annahme, dass die Eltern der Neu-züchtung Riesling und Silvaner seien, entstand außerdem der Name Rivaner. Inzwischen weiß man, dass die Neu-züchtung aus Riesling und der Sorte Madeleine Royal entstanden ist.',
        'Unser Rivaner Dirmsteiner Scharzerde zeigt im Glas ein funkelndes helles Strohelb, in der Nase haben wir fruchtige Noten, deutlich reife Birnen, dahinter blumige Nuancen und eine feine Muskatnote. Der Rivaner ist angenehm leicht und schön spritzig. Unser Urteil: ein wunderbarer Schoppen für wenig Geld!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/jesuitenhof_rivaner_2020.png',
      },
      beginCampaign: '2021-05-01T08:00:00.000+02:00',
      endCampaign: '2021-05-31T20:00:00.000+02:00',
      slug: '21-05',
    },
    {
      id: 200030,
      wineId: 100033,
      type: 'wine-of-month',
      active: true,
      price: '5,90',
      discount: '5,50',
      currency: '€',
      description: [
        '',
        'Aus der Gegend zwischen Basel und Freiburg, aus dem schönen Mark-gräflerland, kommt unser Wein des Monats im Juni 2021 die Weißwein-cuvée sau. gut.. Bernd und Thomas Behringer zwei junge, talentierte Weinmacher aus dem idyllischen Winzerort Britzingen machen für uns diesen leichten Weißwein, der hell-strohgelb im Glas glitzert und intensiv nach Stachelbeeren, grüner Paprika und gelben Früchten duftet. Im Mund wirkt seine feine Säure erfrischend und sein Abgang ist mittellang!',
        'Typisch für das Markgräflerland sind Weine aus der Rebsorte Gutedel! Und so hat unser sau. gut. auch einen hohen Anteil an Gutedel. Das zeigt sich auch im Namen, der erklärt sich aber doch leicht: sau. ist eine Abkürzung für die Rebsorte Sauvignon und gut. ist eben die Abkürzung für die Rebsorte Gutedel. Da der Anteil des Gutedels im Wein höher ist, schreiben die Winzer auch ganz richtig: gut. sau. auf das Etikett!',
        'Und saugut ist der sau. gut.!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/behringer_saugut_2020.png',
      },
      beginCampaign: '2021-06-01T08:00:00.000+02:00',
      endCampaign: '2021-06-30T20:00:00.000+02:00',
      slug: '21-06',
    },
    {
      id: 200031,
      wineId: 100034,
      type: 'wine-of-month',
      active: true,
      price: '5,70',
      discount: '5,20',
      currency: '€',
      description: [
        '',
        'Das Weingut Mathias Dostert ist beheimatet in Nittel an der Obermosel, nahe der Grenze zu Luxembourg. Das familiengeführte Weingut hat sei-nen Fokus auf die Herstellung von Elbling-Weinen und hauseigenen Sekten im klassischen Flaschengärungsverfahren gelegt. Der Name der Rebsorte Elbling hat seinen Ursprung nicht – wie viele meinen – im Namen des Flusses Elbe. Die Römer brachten eine weiße Rebe (uva al-ba) an die Mosel mit. Aus dieser Bezeichnung entstand dann der Reb-sortenname Elbling.',
        'Das Weingut Mathias Dostert verfügt über zwei ausgezeichnete Wein-bergslagen: das Nitteler Leiterchen und den Nitteler Rochusfels. In die-sen Lagen wachsen die Trauben für die trockenen und halbtrockenen Elblinge! Unser Tipp: probieren Sie doch unbedingt auch den großartig süffigen Elbling Classic!',
        'Unser trockener 2020er Elbling in der 1-Liter-Flasche entstammt der Lage Nitteler Leiterchen. Er zeigt im Glas ein schönes helles Strohgelb, duftet fein nach Zitrusfrucht, Stachelbeeren und weißen Blüten, dahin-ter eine zarte mineralische Note. Im Mund ist er frisch, fruchtig und hat einen leicht würzigen Abgang. Ein erfrischender Sommerabend-Terrassenwein!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/weingut-dostert_nitteler-leiterchen_2020.jpg',
      },
      beginCampaign: '2021-07-01T08:00:00.000+02:00',
      endCampaign: '2021-07-31T20:00:00.000+02:00',
      slug: '21-07',
    },
    {
      id: 200032,
      wineId: 100035,
      type: 'wine-of-month',
      active: true,
      price: '9,90',
      discount: '9,40',
      currency: '€',
      description: [
        '',
        'Unser Trastella ist ein fruchtiger, säurearmer Landwein aus der Toskana. Das 37 Hektar große Weingut Villa Trasqua liegt zwischen Siena und Monteriggioni. Der Weißwein besteht zu 100% aus der Rebsorte Vermentino, die unter Weinkennern als eine der charakterstärksten mediterranen Weißweinsorten geschätzt wird und vollmundige Weine mit einer gut ausbalancierten Säure ergibt.',
        'Unser Vermentino hat eine leuchtend strohgelbe Farbe und ein intensives, komplexes Bouquet nach weißen Blüten, Kräutern, Limonen und Anklänge an Ananas. Im Mund hat er eine feine Fruchtmit leicht bitterem mineralischem Unterton. Dies verleiht ihm Struktur und eine gute Länge. Wir empfehlen eine Trinktemperatur von 8°. Die Kombinationsmöglichkeiten zum Essen sind vielfältig: probieren Sie ihn doch zu Fisch, Huhn und Gemüsegerichten oder trinken Sie ihn einfach so!',
        'Versuchen Sie auch vom gleichen Weingut den Rotwein Traluna aus 100% Sangiovese!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/villa-trasqua_trastella_2019.jpg',
      },
      beginCampaign: '2021-08-01T08:00:00.000+02:00',
      endCampaign: '2021-08-31T20:00:00.000+02:00',
      slug: '21-08',
    },

    {
      id: 200033,
      wineId: 100036,
      type: 'wine-of-month',
      active: true,
      price: '10,90',
      discount: '10,40',
      currency: '€',
      description: [
        '',
        'Unser Landwein Coloma Garnacha Selección kommt aus der Extremadura, einer Region in Westspanien an der portugiesi-schen Grenze. Hier werden ausgewogene, fruchtbetonte Weine mit mediterranem Charakter erzeugt. Unser Coloma wird zu 100% aus der roten Rebsorte Garnacha Tintorera gekeltert. In Frankreich – dem Ursprungsland – heißt die Rebe Alicante Bou-schet. ',
        'Ihre Besonderheit besteht darin, dass nicht nur ihre Beeren-haut, sondern auch das Fruchtfleisch rot gefärbt ist. Daher der Namenszusatz: "Tintoreros" bedeutet "der Färber"! Der Coloma Garnacha zeigt ein schönes tief dunkles Kirschrot und hat feine Röstaromen vom 6-monatigen Ausbau im französischen Bar-rique, sowie Aromen nach Tabak, Kakao. Außerdem schöne Fruchtnoten nach Cassis und Brombeeren, und eine würzige Note mit deutlichen, weichen Tanninen. Er besticht er durch seinen sehr kräftigen, langen und intensiven Abgang!',
        'Speiseempfehlung: zu gereiftem Käse, Wildgerichten oder Grill-fleisch mit Röstaromen! Versuchen Sie auch vom gleichen Weingut den Rotwein Coloma Graciano Selección aus dem Jahr 2011! (10,20 €).',
        '',
      ],
      media: {
        imgSrc: '/img/wine/vino_de_la_tierra__garnacha_2017.jpg',
      },
      beginCampaign: '2021-09-01T08:00:00.000+02:00',
      endCampaign: '2021-09-30T20:00:00.000+02:00',
      slug: '21-09',
    },

    {
      id: 200034,
      wineId: 100037,
      type: 'wine-of-month',
      active: true,
      price: '8,20',
      discount: '7,70',
      currency: '€',
      description: [
        '',
        'Die Winzergenossenschaft Laudun Chusclan am Ufer der Rhône besteht aus mehr als 250 Winzern und bewirtschaftet 3000 Hektar Weinberge in 25 Gemeinden. Unser Chusclan, der aus Weinen der Rebsorten Grenache (60 %), Syrah (25 %) und Carignan, Mourvèdre und Cinsault (zusammen 15 %) entsteht, kommt ausschließlich von einem kleinen Weingut mit 45 Hektar dort werden nur sehr geringe 42 Hektoliter pro Hektar geern-tet! Die Vinifikation wird dann von der Genossenschaft über-nommen.',
        'Das Ergebnis kann sich schmecken lassen: Sie erhalten einen perfekt gemachten, klassischen Côtes du Rhône Villages! Unser Chusclan zeigt im Glas ein intensives, mitteltiefes Granatrot, seine Aromen sind kräftig und vielschichtig, er duftet nach schwarzen Beeren (Johannisbeeren, Brombeeren) und Back-pflaumen, dahinter würzige Nuancen (Gewürznelke, Pfeffer), er hat runde, aber spürbare Tannine, eine weiche, harmonische Säure und einem tollen Abgang!',
        '',
        'Probieren Sie auch einmal von den Vignerons Laudun Chusclan:',
        '- Prieurs de St. Julien 2018 1L; Côtes du Rhône AOC (8,30€)',
        '- Les Cosses Vacquières 2018, Lirac AOC (9,30 €)!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/domaine-baraniere_chusclan_2019.jpg',
      },
      beginCampaign: '2021-10-01T08:00:00.000+02:00',
      endCampaign: '2021-10-31T20:00:00.000+02:00',
      slug: '21-10',
    },
    {
      id: 200035,
      wineId: null,
      wineIds: [100038, 100039],
      type: 'wine-of-month',
      active: true,
      prices: ['9,40', '9,20'],
      discounts: ['8,50', '8,50'],
      currency: '€',
      description: [
        '',
        "2012 erwarb die Familie Castan das Weingut Château St. Jean in Gignac, nordwestlich von Montpellier gelegen. Ein Teil ihrer Weinberge liegt in den Terrassen du Larzac, einer Spitzenlage des Languedoc. Hier wachsen die typischen Reben für unseren Rotwein: Syrah, Grenache und Carignan. Für unseren Weißwein l'Autodidacte wurden 2 Parzellen mit der Rhône-Rebsorte Viognier in den Hügeln von Larzac neu angepflanzt.",
        '',
      ],
      detailDescriptions: [
        [
          "Unser l'Autodidacte besteht zu 100 % aus Viognier, der weißen Kultrebe der nördlichen Weinbaugebiete an der Rhône. Erst seit 2017 werden unter diesem Namen Viognier-Weine auf St. Jean d'Aumières erzeugt. Der Wein zeigt im Glas ein schönes, helles Goldgelb. In der Nase haben wir Aromen von Zitrusfrüchten, auch Aprikose und Mango und dahinter eine Spur von Honig. Am Gaumen zeigt sich ein voller Körper, eine dezente Säure und ein erfreulich langer Abgang! Bitte bei 12° trinken!",
        ],
        [
          "Der l'Affranchi 2018 von St. Jean d'Aumières ist eine trockene, elegant gemachte Rotweincuvée aus den typischen Reben des Languedoc: Grenache, Syrah und Carignan. Granatrot in der Farbe, in der Nase Aromen von Brombeere und schwarzer Johannisbeere, dahinter Röstaromen wie Räucherspeck und Kaffee. Der Wein hat gut eingebundene Tannine, eine geringe Säure und ist samtig weich, sein Abgang mittellang! Bitte probieren Sie unbedingt den für die Region außer-gewöhnlichen Weißwein l'Autodidacte und den klassischen Languedoc-Rotwein l'Affranchi von St. Jean d'Aumières! Beide haben ein überzeugendes Preis-Leistungs-Verhältnis!",
        ],
      ],
      media: [
        {
          imgSrc: '/img/wine/chateau-aumieres_lautodidacte_2018.jpg',
        },
        {
          imgSrc: '/img/wine/chateau-aumieres_laffranchi_2018.jpg',
        },
      ],
      beginCampaign: '2021-11-01T08:00:00.000+02:00',
      endCampaign: '2021-11-30T20:00:00.000+02:00',
      slug: '21-11',
    },

    {
      id: 200036,
      wineId: 100040,
      type: 'wine-of-month',
      active: true,
      price: '24,50',
      discount: '23,00',
      currency: '€',
      description: [
        '',
        'Heute empfehlen wir Ihnen einen der großen Rotweine Italiens, den Kultwein aus Venetien: Amarone della Valpolicella! Unser Amarone ist eine trockene, elegante Cuvée aus den Rebsorten Corvinone, Rondinella und Corvina aus dem Herzen des Valpolicella-Gebietes. Trotzdem er trocken ist, wird er ähnlich wie ein Süßwein (Reciotto) gemacht: Ein Teii der Trauben wird vor dem Keltern mindestens 100 Tage getrocknet (Appassimento-Verfahren), wodurch der Wein einen hohen Extrakt- und Alkoholgehalt erhält. Der Namenszusatz "Classico" verrät, dass der Wein im Kerngebiet der DOCG angebaut wird.',
        'Unseren Amarone della Valpolicella zeichnet sein intensives Granatrot aus; die Nase erfreut ein vielschichtiges, konzentriertes Aroma nach Kirschen und getrockneten Früchten wie Dörrpflaumen und Gewürzen mit zarten Anklängen an Lakritze, dahinter gut eingebundene feine Barriquenoten; im Mund komplex mit vollem Körper, harmonisch, weich, geschmeidig mit schöner Balance zwischen Frucht und Würze, Süße und Säure sowie Kraft und Charme – das alles bei einem langen Finish!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/amarone-classico_campagnola_2016.jpg',
      },
      beginCampaign: '2021-12-01T08:00:00.000+02:00',
      endCampaign: '2021-12-31T20:00:00.000+02:00',
      slug: '21-12',
    },

    {
      id: 200037,
      wineId: 100041,
      type: 'wine-of-month',
      active: true,
      price: '7,50',
      discount: '7,00',
      currency: '€',
      description: [
        '',
        'Heute empfehlen wir Ihnen einen Grauburgunder Kabinett trocken vom Tuniberg, einem der neun badischen Weinbaubereiche, im Breisgau etwas südlich des Kaiserstuhls bei Freiburg gelegen. Der Grauburgunder, auch Grauer Burgunder, Ruländer, Pinot Gris oder Pinot Grigio genannt, verdankt seinen Namen der Farbe der Trauben, die einen leichten Graustich bekommen. In Deutschland liegt der Grauburgunder, der zumeist säurearm und körperreich ist, in den letzten Jahren voll im Trend!',
        'Unser Grauburgunder entstammt der Toplage Gottenheimer Kirchberg. Im Glas zeigt er ein strahlendes, kräftiges Strohgelb. Seine Aromen liegen mehr im fruchtigen Bereich, Birne, Melone und Mirabelle, dahinter eine Spur Würzigkeit und ein Honiganklang. Im Mund ist er voll und üppig mit angenehmem Schmelz und überraschend langem Abgang. Insgesamt ist er ein typisch badischer Grauburgunder mit vollem Körper, geschmeidig, fruchtbetont und lange auf der Zunge!',
        'Die Familie Hunn betreibt "nebenbei" auch eine Straußwirtschaft. Die sollten Sie unbedingt besuchen, wenn Sie sich im schönen Breisgau aufhalten!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/gottenheim-am-tuniberg_kabinett_2020.png',
      },
      beginCampaign: '2022-02-01T08:00:00.000+02:00',
      endCampaign: '2022-02-28T20:00:00.000+02:00',
      slug: '22-02',
    },

    {
      id: 200038,
      wineId: 100042,
      type: 'wine-of-month',
      active: true,
      price: '4,90',
      discount: '4,00',
      currency: '€',
      description: [
        '',
        'Die Genossenschaft Cristo de Vega liegt unweit von Ciudad Real im Herzen von La Mancha, dem weltweit größten zusammenhängenden Weinbaugebiet. Cristo de la Vega ist technisch auf dem neuesten Stand und produziert Weine aus nationalen und internationalen Rebsorten von höchster Qualität und zu vernünftigen Preisen!',
        'Airén ist eine autochthone spanische Rebsorte, aus der meistens mit hohen Erträgen sehr einfache Weinqualitäten erzeugt werden. In La Mancha setzt man aber auf Ertragsreduzierung und moderne Kellereitechnik, um saubere und frische Weine mit hohem Qualitätsanspruch zu erzeugen.',
        'Der neue 2021er Airén von Cristo de la Vega hat eine strahlend strohgelbe Farbe, in der Nase herrscht eine Zitrusnote vor, unterlegt mit zarten Aromen von exotischen Früchten. Sie bekommen einen jungen, frisch-fruchtigen und sehr leichten Wein mit ausgewogener Säure; einen wunderbaren Sommerwein! Er passt gut zu Fisch und Meeresfrüchten! Wir empfehlen 6–8° als Trinktemperatur!',
        '',
      ],
      media: {
        imgSrc: '/img/wine/bodegas-cristo-de-la-vega_marques-de-castilla-blanco_2021.png',
      },
      beginCampaign: '2022-04-01T08:00:00.000+02:00',
      endCampaign: '2022-04-30T20:00:00.000+02:00',
      slug: '22-04',
    },

    {
      id: 200039,
      wineId: 100043,
      type: 'wine-of-month',
      active: true,
      price: '8,20',
      discount: '7,50',
      currency: '€',
      description: [
        '',
        '"Seit Jakob Schneider jun. in den elterlichen Betrieb an der Mittleren Nahe einstieg, eilt das Gut von Erfolg zu Erfolg. Etliche Spitzenlagen der Nahe mit 52 Gesteinsformationen bilden die Basis für die ausdrucksstarken Weine des Gutes. Vom einfachsten Wein bis zu den atemberaubenden Spitzen hat jeder Wein Schliff, Würze und Saftigkeit. All das noch dazu zu überaus fairen Preisen." So beurteilte der renommierte Weinführer Gault & Millau Deutschland Jakob Schneider Junior und vergab 4 von 5 Trauben für die Weinkollektion des Gutes. (Vier Trauben bedeuten im Gault & Millau: Deutsche Spitze!). Ein schöneres Kompliment für seine Arbeit hätten wir ihm auch nicht machen können!',
        'Auch bemerkenswert: das Weingut wurde bereits 1575 begründet und befindet sich seitdem in Familienbesitz! Von seinen 18 Hektar Rebfläche entfallen 85% auf Riesling, 10% auf Burgunder-Rebsorten und 5% auf andere Rebsorten. Jakob Schneiders Philosophie: "Bei uns dreht sich alles um Steillagen und den Riesling, der in unseren steilen, skelettreichen Weinbergen optimal gedeiht. Durch eine moderne, schonende Traubenannahme und eine behutsame, lange Vergärung mit traubeneigenen Hefen produzieren wir charaktervolle Weine mit viel Tiefgang."',
        '',
      ],
      media: {
        imgSrc: '/img/wine/weingut-jakob-schneider_melaphyr-riesling-trocken_2020.png',
      },
      beginCampaign: '2022-05-01T08:00:00.000+02:00',
      endCampaign: '2022-05-31T20:00:00.000+02:00',
      slug: '22-05',
    },

    {
      id: 200040,
      wineId: null,
      wineIds: [100044, 100045],
      type: 'wine-of-month',
      active: true,
      prices: ['6,20', '6,20'],
      discounts: ['5,70', '5,70'],
      currency: '€',
      description: [''],
      detailDescriptions: [
        [
          'Sommer, Sonne, Sonnenschein und unbeschwerter Genuss!<br>So lässt sich Sommerlaune am schnellsten beschreiben: spritzig und fruchtig und das bei nur 9,5 % Vol. Alkohol.<br>Die <b>Cuvée Sommerlaune weiß</b> entsteht aus den Rebsorten    Bacchus und Müller-Thurgau und ist fruchtig wie ein voller Obstkorb mit erfrischenden Aromen von grünem Apfel, Limette, Minze und Rosenblüten!',
        ],
        [
          'Die <b>Cuvée Sommerlaune rosé</b> entsteht aus den Rebsorten Acolon und Müller-Thurgau und duftet nach roten Beeren wie Erd- und Himbeeren. Im Mund ist sie leicht und erfrischend mit schönem, mittellangem Abgang. Gut gekühlt getrunken macht Sommerlaune Lust auf eine weitere Flasche!',
        ],
      ],
      media: [
        {
          imgSrc: '/img/wine/winzergenossenschaft-sommerach_cuvee-sommerlaune-weiss_2021.png',
        },
        {
          imgSrc: '/img/wine/winzergenossenschaft-sommerach_cuvee-sommerlaune-rose_2021.png',
        },
      ],
      beginCampaign: '2022-06-01T08:00:00.000+02:00',
      endCampaign: '2022-06-30T20:00:00.000+02:00',
      slug: '22-06',
    },
  ],
})
